import React from "react";
import Select, { components } from "react-select";
import { SELECT_CUSTOM_STYLES } from "constants/CommonConstants";

const CustomMenu = (props) => {
  return (
    <components.Menu {...props}>
      <components.MenuList {...props}>
        {props.children}
      </components.MenuList>

      <div className="add-new-option"
        onClick={() => props.selectProps.onAddNew?.()}
      >
        + Add New
      </div>
    </components.Menu>
  );
};

const customStyles = {
  ...SELECT_CUSTOM_STYLES,
  menuList: (provided) => ({
    ...provided,
    maxHeight: "11rem",
    paddingBottom: 0,
    paddingTop: 0,
  }),
};

function CreatableSelect(props) {
  return (
    <Select
      options={props.options}
      placeholder={props.placeholder}
      classNamePrefix="react-select"
      value={props.value
        ? props.options.find((opt) => opt.value === props.value)
        : null
      }
      onChange={(selected) => {
        props.onChange(selected);
      }}
      isDisabled={props.isDisabled}
      menuPortalTarget={document.body}
      styles={customStyles}
      // menuPosition="fixed"
      className={props.className}
      components={{ Menu: CustomMenu }}
      onAddNew={props.onAddNew}
      isClearable
    />
  );
}

export default CreatableSelect;